import React, { useContext, useEffect, useState } from 'react';
import { Tag } from 'antd';
import { MinusSquareOutlined, PlusSquareOutlined } from '@ant-design/icons';
import StreamChatContainer from '../container/stream-chat-container';
import { AppContext } from '../../../../contexts/AppContext';

const ReportComponentExtContainer: React.FC<any> = (props) => {
  const { property } = props;
  const { setGlobalEvent } = useContext(AppContext);
  const defaultReportData = [];

  const [reportData, setReportData] = useState<any>(defaultReportData);

  const tagColorMap = {
    Aggressive: '#cf1322', // red,
    Conservative: '#08979c', // cyan,
    Moderate: '#d46b08', // orange
  };

  const [detailIndex, setDetailIndex] = useState<number>(1);
  const strategicSelectOption = window.localStorage.getItem('strategicSelectOption');
  const [optionIndex, setOptionIndex] = useState<any>(strategicSelectOption || '3');
  const onDetailClick = (index) => {
    setDetailIndex(index);
  };

  const onOptionClick = (index) => {
    setOptionIndex(index);
    const eventInfo = {
      eventType: 'OPTION_CHANGED',
      index,
    };
    setGlobalEvent(eventInfo);
  };

  useEffect(() => {
    if (property.data && property.data.length > 0) {
      setReportData(property.data);
    }
  }, [property.data]);

  return (
    <>
      <div
        className="container-layout-area"
        style={{
          fontFamily: 'Meiryo SYSTEM-UI',
          backgroundImage: `url(${property.backgroundImageUrl || '/assets/gai/bg.png'})`,
          backgroundSize: 'cover',
        }}
      >
        <div className="container-search-area">
          <span className="container-title">Top 5 Investors' Comment Forecast Report</span>
        </div>
        {reportData.length === 0 ? (
          <></>
        ) : (
          <>
            <div className="report-area" key={optionIndex}>
              <div className="options-list-area">
                <div className="summary-report-title"> </div>
                <div className="summary-report-items">
                  <div className="options-report-item">
                    <div
                      className={optionIndex === '1' ? 'is-selected-item  options-item' : 'options-item'}
                      onClick={() => onOptionClick('1')}
                    >
                      <div className="options-header">
                        <div className="options-title">Option-1</div>
                        <Tag color={tagColorMap['Aggressive']} style={{ margin: 0, fontSize: '1rem', padding: '0.3rem' }}>
                          Aggressive
                        </Tag>
                      </div>
                    </div>
                    <div
                      className={optionIndex === '2' ? 'is-selected-item  options-item' : 'options-item'}
                      onClick={() => onOptionClick('2')}
                    >
                      <div className="options-header">
                        <div className="options-title">Option-2</div>
                        <Tag color={tagColorMap['Aggressive']} style={{ margin: 0, fontSize: '1rem', padding: '0.3rem' }}>
                          Aggressive
                        </Tag>
                      </div>
                    </div>
                    <div
                      className={optionIndex === '3' ? 'is-selected-item  options-item' : 'options-item'}
                      onClick={() => onOptionClick('3')}
                    >
                      <div className="options-header">
                        <div className="options-title">Option-3</div>
                        <Tag color={tagColorMap['Moderate']} style={{ margin: 0, fontSize: '1rem', padding: '0.3rem' }}>
                          Moderate
                        </Tag>
                      </div>
                    </div>
                    <div
                      className={optionIndex === '4' ? 'is-selected-item  options-item' : 'options-item'}
                      onClick={() => onOptionClick('4')}
                    >
                      <div className="options-header">
                        <div className="options-title">Option-4</div>

                        <Tag color={tagColorMap['Conservative']} style={{ margin: 0, fontSize: '1rem', padding: '0.3rem' }}>
                          Conservative
                        </Tag>
                      </div>
                    </div>
                    <div
                      className={optionIndex === '5' ? 'is-selected-item  options-item' : 'options-item'}
                      onClick={() => onOptionClick('5')}
                    >
                      <div className="options-header">
                        <div className="options-title">Option-5</div>
                        <Tag color={tagColorMap['Conservative']} style={{ margin: 0, fontSize: '1rem', padding: '0.3rem' }}>
                          Conservative
                        </Tag>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="report-summary-area">
                <div className="summary-report-title">Executive Summary</div>
                <div className="summary-report-items">
                  <div className="summary-report-item">
                    <div className={detailIndex === 1 ? 'is-selected-item  report-item' : 'report-item'} onClick={() => onDetailClick(1)}>
                      <div className="item-header">
                        <div className="item-index">1</div>
                        <div className="item-title">{reportData[0].title}</div>
                      </div>
                      <div className="item-context">
                        <div className="item-text">
                          <StreamChatContainer property={{ text: reportData[0].contentText }} />
                        </div>
                      </div>

                      {detailIndex !== 1 ? (
                        <PlusSquareOutlined className="detail-button" />
                      ) : (
                        <MinusSquareOutlined className="detail-button" />
                      )}
                    </div>
                  </div>
                  <div className="summary-report-item">
                    <div className={detailIndex === 2 ? 'is-selected-item  report-item' : 'report-item'} onClick={() => onDetailClick(2)}>
                      <div className="item-header">
                        <div className="item-index">2</div>
                        <div className="item-title">{reportData[1].title}</div>
                      </div>
                      <div className="item-context">
                        <div className="item-text">
                          <StreamChatContainer property={{ text: reportData[1].contentText }} />
                        </div>
                      </div>
                      {detailIndex !== 2 ? (
                        <PlusSquareOutlined className="detail-button" />
                      ) : (
                        <MinusSquareOutlined className="detail-button" />
                      )}
                    </div>
                    <div className={detailIndex === 3 ? 'is-selected-item  report-item' : 'report-item'} onClick={() => onDetailClick(3)}>
                      <div className="item-header">
                        <div className="item-index">3</div>
                        <div className="item-title">{reportData[2].title}</div>
                      </div>
                      <div className="item-context">
                        <div className="item-text">
                          <StreamChatContainer property={{ text: reportData[2].contentText }} />
                        </div>
                      </div>
                      {detailIndex !== 3 ? (
                        <PlusSquareOutlined className="detail-button" />
                      ) : (
                        <MinusSquareOutlined className="detail-button" />
                      )}
                    </div>
                  </div>
                  <div className="summary-report-item">
                    <div className={detailIndex === 4 ? 'is-selected-item  report-item' : 'report-item'} onClick={() => onDetailClick(4)}>
                      <div className="item-header">
                        <div className="item-index">4</div>
                        <div className="item-title">{reportData[3].title}</div>
                      </div>
                      <div className="item-context">
                        <div className="item-text">
                          <StreamChatContainer property={{ text: reportData[3].contentText }} />
                        </div>
                      </div>
                      {detailIndex !== 4 ? (
                        <PlusSquareOutlined className="detail-button" />
                      ) : (
                        <MinusSquareOutlined className="detail-button" />
                      )}
                    </div>
                    <div className={detailIndex === 5 ? 'is-selected-item  report-item' : 'report-item'} onClick={() => onDetailClick(5)}>
                      <div className="item-header">
                        <div className="item-index">5</div>
                        <div className="item-title">{reportData[4].title}</div>
                      </div>
                      <div className="item-context">
                        <div className="item-text">
                          <StreamChatContainer property={{ text: reportData[4].contentText }} />
                        </div>
                      </div>
                      {detailIndex !== 5 ? (
                        <PlusSquareOutlined className="detail-button" />
                      ) : (
                        <MinusSquareOutlined className="detail-button" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {detailIndex !== 0 ? (
                <div className="report-detail-area">
                  <div className="detail-report-title">Comment Forecast Detail</div>
                  <div className="detail-report-items">
                    <div className="detail-item is-selected-item">
                      <div className="item-header">
                        <div className="item-index">{detailIndex}</div>
                        <div className="item-title">{reportData[detailIndex - 1].title}</div>
                      </div>
                      <div className="item-context custom-scrollbar">
                        <div className="item-text">
                          <StreamChatContainer key={detailIndex} property={{ text: reportData[detailIndex - 1].contentTextMore }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ReportComponentExtContainer;
